import { Box, Stack } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { descargarFichaEscrituracion, descargarReporteAnexoSeguros, descargarReporteAnexoTabla, descargarReporteCae, descargarReporteTablaDesarrollo, descargarReporteTdValorizada } from "../../services/servicesReportes";
import { StatusCode, TipoTablaDesarrollo } from "../../../../utils/enums";
import { useEffect, useState } from "react";
import { useToast } from "../../../../hooks/useToast";
import { getNumeroSolicitud } from "./service/serviceDescarga";
import { getOperacion } from "../../services/servicesOperacion";

const tipoProductosSinCuotaMaxima: string[] = ['MHT', 'MHD'];

interface IProps {
    mutuoId: number;
}

function DescargasForm({ mutuoId }: IProps): JSX.Element {
    const [tipoProducto, setTipoProducto] = useState<string>('');

    useEffect(() => {
        const fetchOperacion = async () => {
            const resp = await getOperacion(mutuoId);
            if (resp.status === StatusCode.Ok) {
                setTipoProducto(resp.data?.tipoProducto ?? '');
            }
        };
        fetchOperacion();
    }, [mutuoId]);

    const mostrarCuotaMaxima = !tipoProductosSinCuotaMaxima.includes(tipoProducto);

    const handleDescargarContrato = async () => {
        const resp = await getNumeroSolicitud(mutuoId);
        const numeroSolicitud = resp.data?.result;

        if (resp.status === StatusCode.Ok && typeof numeroSolicitud === "number") {
            descargarReporteCae(numeroSolicitud);
        }
    };

    return (
        <Box sx={{ mt: 2 }}>
            <Stack spacing={1} direction="column">
                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() => descargarFichaEscrituracion(mutuoId)}
                >
                    Ficha de escrituración
                </MButton>

                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() =>
                        descargarReporteTablaDesarrollo(mutuoId, TipoTablaDesarrollo.CuotaMinima)
                    }
                >
                    Tabla de desarrollo cuota mínima
                </MButton>

                {mostrarCuotaMaxima && (
                    <MButton
                        variant="outlined"
                        startIcon={<FileDownloadIcon />}
                        onClick={() =>
                            descargarReporteTablaDesarrollo(mutuoId, TipoTablaDesarrollo.CuotaMaxima)
                        }
                    >
                        Tabla de desarrollo cuota máxima
                    </MButton>
                )}

                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() =>
                        descargarReporteTdValorizada(mutuoId)
                    }
                >
                    Tabla de desarrollo cuota mínima valorizada
                </MButton>

                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() => descargarReporteAnexoTabla(mutuoId)}
                >
                    Anexo de tabla
                </MButton>

                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() => descargarReporteAnexoSeguros(mutuoId)}
                >
                    Anexo de seguros
                </MButton>

                <MButton
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={handleDescargarContrato}
                >
                    Resumen contrato
                </MButton>
            </Stack>
        </Box>
    );
}
export default DescargasForm
